module.exports = __webpack_public_path__ + "img/1405.cdc74790.jpg";